import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA service worker (#214).
// onUpdate: when a new SW is waiting, tell it to skip waiting then reload
// so users always get fresh content automatically — no Ctrl+Shift+R needed.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    });
  },
});